import QRCode from 'qrcode';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import {UAParser} from 'ua-parser-js';
import PerfectScrollbar from 'perfect-scrollbar';
import i18n from '@/i18n/main';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(utc);
dayjs.extend(timezone);

import {
  CURRENT_USER_STATE,
  INQUIRY_TYPE,
  USER_STATE_MESSAGE,
  CUSTOM_COMPANIES,
  USER_STATUS,
} from './constants';

export const getParameterByName = function (name, url = window.location.href) {
  name = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

// #FIXME: getQueryParameters와 동일
export function getUrlParams(url) {
  var params = {};
  url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
    params[key] = value;
  });
  return params;
}

// #FIXME: getUrlParams와 동일
export const getQueryParameters = function (search) {
  const urlParams = new URLSearchParams(search);
  let parameters = {};
  for (let key of urlParams.keys()) {
    parameters[key] = urlParams.get(key);
  }
  return parameters;
};

export function isEmpty(value) {
  return value === null || value === undefined;
}

export function updateQueryParameter(uri, key, value) {
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return uri + separator + key + '=' + value;
  }
}

export function getFullName(user) {
  const fullName =
    (user.lastName ? user.lastName : '') +
    (user.firstName ? user.firstName : '');
  return isEmpty(fullName) ? (isEmpty(user.name) ? '' : user.name) : fullName;
}

export function makeQueryString(param) {
  var qs = '';
  for (var i = 0; i < Object.keys(param).length; i++) {
    var delimiter = i === 0 ? '?' : '&';
    qs += delimiter + Object.keys(param)[i] + '=' + Object.values(param)[i];
  }

  return qs;
}

export function makeQR(imgEl, url) {
  const [href, searchParam] = url.split('?');
  const enableKeys = ['userid', 'token', 'idCard', 'idType', 'global'];

  let queryParams = {};
  const params = new URLSearchParams(searchParam);
  params.forEach((value, key) => {
    if (enableKeys.includes(key)) queryParams[key] = value;
  });

  // object로부터 querystring 생성
  const queryString = Object.entries(queryParams)
    .map(([key, value]) => value && key + '=' + value)
    .filter(v => v)
    .join('&');

  const makeUrl = `${href}?${queryString}`;

  QRCode.toDataURL(makeUrl).then(img => {
    if (imgEl) {
      imgEl.setAttribute('src', img);
    }
  });
}

export function generateUUID() {
  let d = new Date().getTime(),
    d2 =
      (typeof performance !== 'undefined' &&
        performance.now &&
        performance.now() * 1000) ||
      0;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16;
    if (d > 0) {
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
/**
 *
 * @param {*} 시험
 * @param {*} 과목
 * @param {*} 응시생
 *
 *
 */
export function getCurrentUserStatus(exam, period, user) {
  const {registrationStart, registrationStatus, loginFailAction} = exam;
  const {periodStart, periodEnd, enterMinAgo, exitMinAfter, resTime} = period;
  const {isPreRegistered, companyId, status} = user;

  let result = {
    state: '',
    text: '',
    isOpen: false,
    isDisabled: false,
  };

  // timezone으로 변경 서버 utc - 0
  const now = dayjs(resTime);
  // 시험의 사전등록 시작일, 종료일
  const preRegistrationStart = dayjs(registrationStart);
  const periodStartSubtract = dayjs(periodStart).subtract(
    enterMinAgo,
    'minutes',
  );
  const periodEndAdd = dayjs(periodEnd).add(exitMinAfter, 'minutes');

  const todayUtc = dayjs(now);

  // 현재 시험중 여부
  const isExamNow =
    todayUtc.isSameOrAfter(periodStartSubtract) &&
    todayUtc.isSameOrBefore(periodEndAdd);

  if (todayUtc.isSameOrBefore(preRegistrationStart)) {
    // 사전등록이 아직 시작되지 않음
    result = {
      state: CURRENT_USER_STATE.BEFORE_PRE_REGISTRATION,
      text: USER_STATE_MESSAGE.BEFORE_PRE_REGISTRATION,
      emailCase: false,
      isOpen: true,
      isDisabled: true,
    };
  } else if (
    todayUtc.isSameOrAfter(periodEndAdd) ||
    (companyId === CUSTOM_COMPANIES.KT && status === USER_STATUS.END)
  ) {
    // 시험이 종료됨
    result = {
      state: CURRENT_USER_STATE.EXAM_END,
      text: USER_STATE_MESSAGE.EXAM_END,
      guide: USER_STATE_MESSAGE.ON_EXAM_GUIDE,
      emailCase: true,
      isOpen: false,
      isDisabled: true,
    };
  } else {
    // 사전등록 완료
    if (isPreRegistered || loginFailAction === 'pass') {
      if (isExamNow) {
        // 과목이 시작함
        result = {
          state: CURRENT_USER_STATE.EXAM_ON,
          text: USER_STATE_MESSAGE.ON_EXAM,
          guide: USER_STATE_MESSAGE.ON_EXAM_GUIDE,
          emailCase: true,
          isOpen: true,
          isDisabled: false,
        };
      } else {
        // 과목이 시작하지 않음 강제 마감 됨 / 안됨
        if (registrationStatus) {
          result = {
            state: CURRENT_USER_STATE.PRE_REGISTRATION_FORCE_CLOSED,
            text: USER_STATE_MESSAGE.PRE_REGISTRATION_FORCE_CLOSED,
            guide: USER_STATE_MESSAGE.PRE_REGISTRATION_FORCE_CLOSED_GUIDE,
            emailCase: true,
            isOpen: false,
            isDisabled: true,
          };
        } else {
          result = {
            state: CURRENT_USER_STATE.PRE_REGISTRATION_COMPLETE,
            text: USER_STATE_MESSAGE.PRE_REGISTRATION_COMPLETE,
            emailCase: false,
            isOpen: true,
            isDisabled: false,
          };
        }
      }
    } else {
      // 사전 등록 미완료
      if (registrationStatus) {
        result = {
          state: CURRENT_USER_STATE.PRE_REGISTRATION_FORCE_CLOSED,
          text: USER_STATE_MESSAGE.PRE_REGISTRATION_FORCE_CLOSED,
          guide: USER_STATE_MESSAGE.PRE_REGISTRATION_FORCE_CLOSED_GUIDE,
          emailCase: true,
          isOpen: false,
          isDisabled: true,
        };
      } else {
        result = {
          state: CURRENT_USER_STATE.PRE_REGISTRATION,
          text: USER_STATE_MESSAGE.PRE_REGISTRATION,
          emailCase: false,
          isOpen: true,
          isDisabled: false,
        };
      }
    }
  }

  return result;
}

export function checkIsOtmUserStreamId(streamId) {
  return streamId !== null && streamId !== undefined && streamId !== ''
    ? /^(pre|final)_(dev|prod)_[0-9]+_(webcam|mobile|screen)/.test(streamId)
    : false;
}
export function getOtmUserInfoWithStreamId(streamId, seperator = '_') {
  return !streamId ? ['', '', '', ''] : streamId.split(seperator);
}

export function sendPostMessage({type, message}) {
  window.parent.postMessage({
    type: type,
    message: message,
  });
}

export const getInquiryLink = exam => {
  let scheme = '';
  if (exam.contactType === INQUIRY_TYPE.MAIL) {
    scheme = 'mailto:';
  } else if (exam.contactType === INQUIRY_TYPE.TEL) {
    scheme = 'tel:';
  }
  return (scheme += exam.contactLink);
};

export const getInquiryTarget = exam => {
  return exam.contactType === INQUIRY_TYPE.URL ? '_blank' : '_self';
};

export function isMobile() {
  const {device} = UAParser(navigator.userAgent);

  if (device.type === 'mobile') {
    return true;
  }
  return false;
}

export const isTablet = () => {
  const {device} = UAParser(navigator.userAgent);
  if (device.type === 'tablet') {
    return true;
  }
  return false;
};

export const changeScrollStyle = () => {
  const nodeList = document.querySelectorAll('.ps');
  if (nodeList)
    nodeList.forEach(node => {
      const ps = new PerfectScrollbar(node);
      ps.update();
    });
};

export const changeLocale = companyId => {
  if (companyId === CUSTOM_COMPANIES.GTELP_GLOBAL) {
    i18n.locale = 'en';
  }
};
